// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__ZPWAf","pressed":"Burger_pressed__u5czE"};